import {getSessionSnapshot} from '../state/session-state'

export const getSessionUser = () => getSessionSnapshot().user
export const isLoggedIn = () => !!getSessionUser()?.id
